// extracted by mini-css-extract-plugin
export default {"separator":"Separator_separator__KqSh0","bold":"Separator_bold__SSzUH"};